function sendBody(method) {
    return (method === 'POST' ||
        method === 'PUT' ||
        method === 'PATCH' ||
        method === 'DELETE');
}
export function proxyFetchToApiRoute(proxyPath, baseUrl = process.env.NEXT_PUBLIC_BASE_PATH) {
    return {
        async onRequest({ request }) {
            const url = new URL(request.url);
            const proxyUrl = new URL(window.location.origin);
            proxyUrl.pathname = baseUrl + proxyPath + url.pathname;
            proxyUrl.search = url.search;
            const { getSession } = await import('@side/next-auth/react');
            const session = await getSession();
            if (!session || !session.accessToken) {
                console.error('[@side/next-tools] Client session not found, throwing error');
                throw new Error('Authentication required');
            }
            request.headers.set('Authorization', `Bearer ${session.accessToken}`);
            const proxyReq = new Request(proxyUrl, {
                method: request.method,
                body: sendBody(request.method) ? await request.blob() : undefined,
                headers: request.headers,
            });
            return proxyReq;
        },
    };
}
